import RegionsGrowthAction from "../actions/regionsGrowthAction";

const RegionsGrowthReducer = (state = { isReagionGrowthLoading: false }, action) => {
    switch (action.type) {
        case RegionsGrowthAction.REGIONS_GROWTH_REQUEST:
            return {
                ...state,
                isReagionGrowthLoading: true
            };
        case RegionsGrowthAction.REGIONS_GROWTH_SUCCESSFUL:
            return {
                ...state,
                isReagionGrowthLoading: false,
                regionGrowth: action.data.data.RegoinGrowth,
                errorMessage: null
            };
        case RegionsGrowthAction.REGIONS_GROWTH_FAILED:
            return {
                ...state,
                errorMessage: action.error,
                regionGrowth: {},
                isReagionGrowthLoading: false
            };
        default:
            return {
                ...state
            };
        //   break;
    }
};

export default RegionsGrowthReducer;
